export const SET_DEVICE_INFO = 'SET_DEVICE_INFO';

export function setDeviceInfo(deviceInfo) {
  return {
    type: SET_DEVICE_INFO,
    deviceInfo,
  };
}
